<app-page-header header="{{language.aboutusheader}}" backgroundPath="assets/images/lead/new-abus-2-2.jpg"
  [isAboutUs]="true">
</app-page-header>

<section class="content-inner">

  <div class="contaner">

    <div class="tab-listing">
      <section class="section-select -menu  d-block d-lg-none">
        <app-dropdown [title]="pageTitle" [valueDropdown]="valueDropdown" (selected)="selectValue($event)">
        </app-dropdown>
      </section>
      <ul class="nav nav-tabs d-none d-lg-inline-block">
        <li class="nav-item">
          <a class="nav-link active" id="one-tab" data-toggle="tab" href="#one" role="tab" aria-controls="one"
            aria-selected="true" (click)="selectValue(1)">
            {{language.aboutusmenu1}}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link " id="two-tab" data-toggle="tab" href="#two" role="tab" aria-controls="two"
            aria-selected="false" (click)="selectValue(2)">
            {{language.aboutusmenu2}}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link " id="three-tab" data-toggle="tab" href="#three" role="tab" aria-controls="three"
            aria-selected="false" (click)="selectValue(3)">
            {{language.aboutusmenu3}}
          </a>
        </li>
      </ul>
    </div>

    <div ngs class="tab-content" id="myTabContent">
      <div [ngSwitch]="choiceFromSelect">

        <div *ngSwitchCase="'History'" class="tab-pane fade show active" id="one" role="tabpanel"
          aria-labelledby="one-tab">
          <section class="history">
            <div class="container">
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <div class="history-content">
                    <h4 class="topic-title">{{language.aboutustopic1}}</h4>
                    <p class="text" style="text-align:justify;text-justify:auto;" [innerHTML]="textAboutusdetail">

                    </p>
                    <div class="row">

                      <div class="col-md-6 col-lg-4 abu-container" style="text-align: center;">
                        <div class="abu-img img-1"></div>
                        <span class="img-desc">{{language.aboutusslogan1}}</span>
                      </div>

                      <div class="col-md-6 col-lg-4 abu-container" style="text-align: center;">
                        <div class="abu-img img-2"></div>
                        <span class="img-desc">{{language.aboutusslogan2}}</span>
                      </div>

                      <div class="col-md-6 col-lg-4 offset-md-3 offset-lg-0 abu-container" style="text-align: center;">
                        <div class="abu-img img-3"></div>
                        <span class="img-desc">{{language.aboutusslogan3}}</span>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </section>
        </div>

        <div *ngSwitchCase="'Manager'" class="tab-pane fade show" id="two" role="tabpanel" aria-labelledby="two-tab">
          <section class="history">
            <div class="container">
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <div class="director-content">

                    <section class="content-1">
                      <h4 class="topic-title">{{language.aboutustopic2}}</h4>
                      <div class="special-row offset-lg-1">
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-5"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname4}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole4}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-2"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname1}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole1}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-3"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname2}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole2}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-4"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname3}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole3}}</span>
                          </div>
                        </div>

                      </div>

                      <div class="special-row offset-lg-1 mt-md-5 mb-md-5">

                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-6"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname5}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole5}}</span>
                          </div>
                        </div>

                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-7"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname6}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole6}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-15"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname15}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole3}}</span>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section class="content-2">
                      <h4 class="topic-title">{{language.aboutustopic3}}</h4>
                      <div class="special-row offset-lg-1">
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-4"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname7}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole7}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-9"></div>
                          <div class="name-tag">
                            <span *ngIf="flag == 'th';else elsename">{{language.aboutusname10}}</span>
                            <ng-template #elsename>
                              <span style="font-size: 13px;">{{language.aboutusname10}}</span>
                            </ng-template>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole10}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-11"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname11}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole11}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-12"></div>
                          <div class="name-tag">
                            <span *ngIf="flag == 'th';else elsename">{{language.aboutusname12}}</span>
                            <ng-template #elsename>
                              <span style="font-size: 13px;">{{language.aboutusname12}}</span>
                            </ng-template>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole12}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="special-row offset-lg-1">
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-13"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname13}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole13}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-15"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname15}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole15}}</span>
                          </div>
                        </div>
                        <div class="col-md-6 col-lg-3" style="text-align: center;">
                          <div class="director-img img-14"></div>
                          <div class="name-tag">
                            <span>{{language.aboutusname14}}</span>
                          </div>
                          <div class="position">
                            <span>{{language.aboutusrole14}}</span>
                          </div>
                        </div>
                      </div>


                    </section>
                  </div>
                </div>
              </div>

            </div>
          </section>
        </div>

        <div *ngSwitchCase="'Organize'" class="tab-pane fade show" id="three" role="tabpanel"
          aria-labelledby="three-tab">
          <section>
            <div class="container">
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <div class="organization-chart-content">
                    <img *ngIf="flag == 'th';else elseOrganization" class="w-100"
                      src="../../../assets/images/aboutus/Organization-Chart.jpg">
                    <ng-template #elseOrganization>
                      <img class="w-100" src="../../../assets/images/aboutus/Organization-Chart-Eng.jpg">
                    </ng-template>
                  </div>
                </div>
              </div>

            </div>
          </section>
        </div>
      </div>

    </div>

  </div>
</section>